import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;

export const adminLogin = createAsyncThunk(
    'admin/adminLogin',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/auth/v1/login', rejectWithValue)
)

export const verifyMfa = createAsyncThunk(
    'admin/verifyMfa',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/auth/v1/verify-mfa', rejectWithValue)
)

export const resendMfa = createAsyncThunk(
    'admin/resendMfa',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/auth/v1/resend-mfa', rejectWithValue)
)

export const adminLogout = createAsyncThunk(
    'admin/adminLogout',
    (arg, { rejectWithValue }) => DataService.get(arg, path+'client/account/v1/logout', rejectWithValue)
)

export const forgotPassword = createAsyncThunk(
    'admin/forgotPassword',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/auth/v1/forgot-password', rejectWithValue)
)

export const changePassword = createAsyncThunk(
    'admin/changePassword',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/account/v1/change-password', rejectWithValue)
)

export const resetPassword = createAsyncThunk(
    'admin/resetPassword',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/auth/v1/reset-password', rejectWithValue)
)

export const updateProfile = createAsyncThunk(
    'admin/updateProfile',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/account/v1/edit-profile', rejectWithValue)
)

export const getProfile = createAsyncThunk(
    'admin/getProfile',
    (arg, { rejectWithValue }) => DataService.get(arg, path+'client/account/v1/profile', rejectWithValue)
)

export const getHome = createAsyncThunk(
    'admin/getHome',
    (arg, { rejectWithValue }) => DataService.get(arg, path+'client/account/v1/home', rejectWithValue)
)

export const activateUser = createAsyncThunk(
    'admin/activateUser',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/auth/v1/activate-account', rejectWithValue)
)

export const addSectionToHome = createAsyncThunk(
    'admin/addSectionToHome',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/account/v1/home/add-section', rejectWithValue)
)

export const reorderSections = createAsyncThunk(
    'admin/reorderSections',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/account/v1/home/reorder', rejectWithValue)
)

export const deleteSectionFromHome = createAsyncThunk(
    'admin/deleteSectionFromHome',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/account/v1/home/delete-section', rejectWithValue)
)

export const deleteFileFromSection = createAsyncThunk(
    'admin/deleteFileFromSection',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/account/v1/home/delete-file', rejectWithValue)
)